import React, { useState, useEffect } from 'react';
import { MobileSelect } from '../components/ui/mobile-select';
import axios from '../lib/axios';
import Navbar from '../components/Navbar';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Minimal test page that EXACTLY replicates CreateListingPage's category dropdown
 * No Navbar, no dialogs, just the raw functionality
 */
const CategoryTestPage = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [loading, setLoading] = useState(true);

  // Fetch categories exactly like CreateListingPage does
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${API}/api/categories`);
        setCategories(res.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching categories:', error);
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const handleChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <p className="text-foreground">Loading categories...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="p-4 pt-20">
        <div className="max-w-md mx-auto pt-8">
          <h1 className="text-2xl font-bold text-foreground mb-6">Category Test (met Navbar)</h1>
          
          <p className="text-sm text-muted-foreground mb-4">
            Test de dropdown met de Navbar en isolation context.
          </p>

          <div 
            className="relative z-10"
            style={{ 
              overflow: 'visible',
              isolation: 'isolate'
            }}
          >
            <form onSubmit={(e) => e.preventDefault()} style={{ overflow: 'visible' }}>
              <div className="relative z-[100]" style={{ overflow: 'visible' }}>
                <label className="block text-sm font-medium text-foreground mb-1.5">Category *</label>
                <MobileSelect
                  name="category"
                  value={selectedCategory}
                  onChange={handleChange}
                  options={categories.map(cat => ({
                    value: cat.id,
                    label: cat.name
                  }))}
                  placeholder="Select category"
                  data-testid="category-select"
                  label="Select Category"
                  className="w-full px-4 py-2.5 rounded-xl border border-border bg-background text-foreground text-sm"
                />
              </div>
            </form>
          </div>

          {selectedCategory && (
            <div className="mt-4 p-4 bg-green-500/10 border border-green-500/30 rounded-xl">
              <p className="text-green-600 text-sm">
                Geselecteerde categorie: <strong>{selectedCategory}</strong>
              </p>
            </div>
          )}

          <div className="mt-8 p-4 bg-muted rounded-xl">
            <p className="text-xs text-muted-foreground">
              {categories.length} categorieën geladen
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryTestPage;
